<!--<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header row mb-1">
      <app-breadcrumb class="col-12" [breadcrumb]="breadcrumb"></app-breadcrumb>
    </div>
    <div class="content-body">
      <form name="clientForm" #clientForm="ngForm" (ngSubmit)="SaveClient(clientForm)" novalidate>
        <div class="modal-header">
          <h4 class="modal-title" id="myModalLabel4">{{action}} Client</h4>
          <button type="button" class="close" aria-label="Close" (click)="closePopup(clientForm,ClientChangesConfirmation)">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-body">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label>Company Name </label> <label *ngIf="action != 'View'" class="danger">*</label>
                  <input type="text" class="form-control" required name="companyName" #companyName="ngModel" [ngClass]="{ 'is-invalid': clientForm.submitted && companyName.errors }" maxlength="30" whiteSpaceValidator placeholder="Enter Company Name" [disabled]="action == 'View'" [(ngModel)]="client.companyName" />
                  <div *ngIf="clientForm.submitted && companyName.errors" class="invalid-feedback">
                    <div *ngIf="companyName.errors['required']"></div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">

                <div class="form-group">
                  <label>Logo</label><label *ngIf="action != 'View'" class="danger">*</label>
                  <div class="custom-file">-->
<!--(change)="onFileChange($event.target.files)"-->
<!--<input type="file" class="custom-file-input" id="importFile" accept="image/*" required (change)="onFileChange($event.target.files)">
<label class="custom-file-label">{{logoChoosefile}}</label>-->
<!--<button type="button" value="upload" (click)="upload()"></button>-->
<!--</div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group">
      <label>Product Name</label><label *ngIf="action != 'View'" class="danger">*</label>
      <select name="productName" (change)="GetProductUId($event)" class="form-control" [disabled]="action == 'View'" [(ngModel)]="client.productUId" #productName="ngModel" required
              [ngClass]="{ 'is-invalid': clientForm.submitted && productName.errors }">
        <option [value]="pro.productUId" *ngFor="let pro of ProductDetailsList">
          {{pro.productName}}
        </option>
      </select>
    </div>
  </div>
</div>
<div class="modal-header">
  <h4 class="modal-title" id="myModalLabel4"> Personal Information</h4>
</div>
<br />
<div class="row">
  <div class="col-md-4">
    <div class="form-group">
      <label>Full Name </label> <label *ngIf="action != 'View'" class="danger">*</label>
      <input type="text" class="form-control" required name="fullName" maxlength="20" #fullName="ngModel" [ngClass]="{ 'is-invalid': clientForm.submitted && fullName.errors }" whiteSpaceValidator placeholder="Enter Name" [disabled]="action == 'View'" [(ngModel)]="client.fullName" />
      <div *ngIf="clientForm.submitted && fullName.errors" class="invalid-feedback">
        <div *ngIf="fullName.errors['required']"></div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group">
      <label>Date Of Birth</label> <label *ngIf="action != 'View'" class="danger">*</label>
      <div class="input-group">
        <input class="form-control" name="dateofBirth" required [disabled]="action == 'View'" [max]="getToday()" [(ngModel)]="client.dateofBirth" #dateofBirth="ngModel" [ngClass]="{ 'is-invalid': clientForm.submitted && dateofBirth.errors }" data-date-format="DD MMMM YYYY" type="date">
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group">
      <label>Gender</label><label *ngIf="action != 'View'" class="danger">*</label>
      <div>
        <div class="d-inline-block custom-control custom-radio mr-1">
          <input type="radio" class="custom-control-input" name="gender" id="colorRadio1" [(ngModel)]="client.gender" value="Male" #colorRadio1="ngModel" required
                 [ngClass]="{ 'is-invalid': clientForm.submitted && colorRadio1.errors }">
          <label class="custom-control-label" for="colorRadio1">Male</label>
        </div>
        <div class="d-inline-block custom-control custom-radio mr-1">
          <input type="radio" class="custom-control-input" name="gender" id="colorRadio2" [(ngModel)]="client.gender" value="Female" #colorRadio2="ngModel" required
                 [ngClass]="{ 'is-invalid': clientForm.submitted && colorRadio2.errors }">
          <label class="custom-control-label" for="colorRadio2">Female</label>
        </div>
        <div class="d-inline-block custom-control custom-radio mr-1">
          <input type="radio" class="custom-control-input" name="gender" id="colorRadio3" [(ngModel)]="client.gender" value="others" #colorRadio3="ngModel" required
                 [ngClass]="{ 'is-invalid': clientForm.submitted && colorRadio3.errors }">
          <label class="custom-control-label" for="colorRadio3">others</label>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-4">
    <div class="form-group">
      <label>Company Certificate Number </label><label *ngIf="action != 'View'" class="danger">*</label>
      <input type="text" class="form-control" required name="companyCertificateNumber"
             #companyCertificateNumber="ngModel"
             [ngClass]="{ 'is-invalid': clientForm.submitted && companyCertificateNumber.errors }"
             maxlength="15" minlength="15" whiteSpaceValidator pattern="[A-Za-z0-9]+" placeholder="Enter CC.No(Ex:98THUBD89RFG906)"
             [disabled]="action == 'View'" [(ngModel)]="client.companyCertificateNumber" />
      <div *ngIf="clientForm.submitted && companyCertificateNumber.errors" class="invalid-feedback">
        <div *ngIf="companyCertificateNumber.errors['required']"></div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group">
      <label>Aadhar Number </label><label *ngIf="action != 'View'" class="danger">*</label>
      <input type="text" class="form-control" required name="aadharNumber" #aadharNumber="ngModel"
             [ngClass]="{ 'is-invalid': clientForm.submitted && aadharNumber.errors }" maxlength="12" minlength="12"
             whiteSpaceValidator numberValidator placeholder="Enter Aadhar No."
             [disabled]="action == 'View'" [(ngModel)]="client.aadharNumber" />
      <div *ngIf="clientForm.submitted && aadharNumber.errors" class="invalid-feedback">
        <div *ngIf="aadharNumber.errors['required']"></div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group">
      <label>PAN Number </label> <label *ngIf="action != 'View'" class="danger">*</label>
      <input type="text" class="form-control" required name="panNumber" #panNumber="ngModel" minlength="10" pattern="[A-Za-z0-9]+"
             [ngClass]="{ 'is-invalid': clientForm.submitted && panNumber.errors }" placeholder="Enter PAN No"
             maxlength="10" whiteSpaceValidator [disabled]="action == 'View'" [(ngModel)]="client.panNumber" />
      <div *ngIf="clientForm.submitted && panNumber.errors" class="invalid-feedback">
        <div *ngIf="panNumber.errors['required']"></div>
      </div>
    </div>
  </div>

</div>
<div class="row">
  <div class="col-md-4">
    <div class="form-group">
      <label>GST Number </label> <label *ngIf="action != 'View'" class="danger">*</label>
      <input type="text" class="form-control" required name="gstNumber" #gstNumber="ngModel" minlength="15" pattern="[A-Za-z0-9]+" [ngClass]="{ 'is-invalid': clientForm.submitted && gstNumber.errors }" placeholder="Enter GST No(Ex:33YN6754VGH897D)" whiteSpaceValidator maxlength="15" [disabled]="action == 'View'" [(ngModel)]="client.gstNumber" />
      <div *ngIf="clientForm.submitted && gstNumber.errors" class="invalid-feedback">
        <div *ngIf="gstNumber.errors['required']"></div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group">
      <label>Email Address </label> <label *ngIf="action != 'View'" class="danger">*</label>
      <input type="text" class="form-control" required name="emailAddress" #emailAddress="ngModel" [ngClass]="{ 'is-invalid': clientForm.submitted && emailAddress.errors }" pattern="^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$" placeholder="Enter EmailID" maxlength="35" whiteSpaceValidator email [disabled]="action == 'View'" [(ngModel)]="client.emailAddress" />

      <div *ngIf="clientForm.submitted && emailAddress.errors" class="invalid-feedback">
        <div *ngIf="emailAddress.errors['required']"></div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group">
      <label>Phone Number(Home) </label>
      <input type="text" class="form-control" placeholder="Enter Home PhoneNo(Optional)"
             minlength="10" name="phoneNumberHome" maxlength="10" whiteSpaceValidator numberValidator #phoneNumberHome="ngModel" [ngClass]="{ 'is-invalid': clientForm.submitted && phoneNumberHome.errors }" [disabled]="action == 'View'" [(ngModel)]="client.phoneNumberHome" />
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-4">
    <div class="form-group">
      <label>Mobile Number1 </label> <label *ngIf="action != 'View'" class="danger">*</label>
      <input type="text" class="form-control" required name="mobileNumber1" minlength="10"
             placeholder="Enter Mobile No." #mobileNumber1="ngModel"
             [ngClass]="{ 'is-invalid': clientForm.submitted && mobileNumber1.errors }" maxlength="10"
             whiteSpaceValidator numberValidator [disabled]="action == 'View'" [(ngModel)]="client.mobileNumber1" />
      <div *ngIf="clientForm.submitted && mobileNumber1.errors" class="invalid-feedback">
        <div *ngIf="mobileNumber1.errors['required']"></div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group">
      <label>Mobile Number2 </label>
      <input type="text" class="form-control" name="mobileNumber2" minlength="10" placeholder="Mobile No2(Optional)" maxlength="10"
             whiteSpaceValidator #mobileNumber2="ngModel" [ngClass]="{ 'is-invalid': clientForm.submitted && mobileNumber2.errors }" numberValidator [disabled]="action == 'View'" [(ngModel)]="client.mobileNumber2" />
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group">
      <label>Country </label> <label *ngIf="action != 'View'" class="danger">*</label>
      <input type="text" class="form-control" required name="country" placeholder="Enter Country" pattern="^[a-zA-Z_ ]*$" #country="ngModel" [ngClass]="{ 'is-invalid': clientForm.submitted && country.errors }" maxlength="20" whiteSpaceValidator [disabled]="action == 'View'" [(ngModel)]="client.country" />
      <div *ngIf="clientForm.submitted && country.errors" class="invalid-feedback">
        <div *ngIf="country.errors['required']"></div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-4">
    <div class="form-group">
      <label>City </label> <label *ngIf="action != 'View'" class="danger">*</label>
      <input type="text" class="form-control" required name="city" #city="ngModel" placeholder="Enter City" pattern="^[a-zA-Z_ ]*$" [ngClass]="{ 'is-invalid': clientForm.submitted && city.errors }" maxlength="20" whiteSpaceValidator [disabled]="action == 'View'" [(ngModel)]="client.city" />
      <div *ngIf="clientForm.submitted && city.errors" class="invalid-feedback">
        <div *ngIf="city.errors['required']"></div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group">
      <label>Zip Code </label> <label *ngIf="action != 'View'" class="danger">*</label>
      <input type="text" class="form-control" required name="zipCode" #zipCode="ngModel" [ngClass]="{ 'is-invalid': clientForm.submitted && zipCode.errors }" maxlength="6" minlength="6" whiteSpaceValidator numberValidator placeholder="Enter Zipcode" [disabled]="action == 'View'" [(ngModel)]="client.zipCode" />
      <div *ngIf="clientForm.submitted && zipCode.errors" class="invalid-feedback">
        <div *ngIf="zipCode.errors['required']"></div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-12">
    <div class="form-group">
      <label>Address </label> <label *ngIf="action != 'View'" class="danger">*</label>
      <textarea class="form-control" id="basicTextarea" #address="ngModel" placeholder="Enter Address" [ngClass]="{ 'is-invalid': clientForm.submitted && address.errors }" whiteSpaceValidator rows="3" required name="address" [disabled]="action == 'View'" [(ngModel)]="client.address"></textarea>
      <div *ngIf="clientForm.submitted && address.errors" class="invalid-feedback">
        <div *ngIf="address.errors['required']"></div>
      </div>
    </div>
  </div>
</div>

<div class="modal-header">
  <h4 class="modal-title" id="myModalLabel4"> Company Information(if applicable)</h4>

</div>

<br />
<div class="row">

  <div class="col-md-4">
    <div class="form-group">
      <label>Industry </label> <label *ngIf="action != 'View'" class="danger">*</label>
      <input type="text" class="form-control" required name="industry" #industry="ngModel" placeholder="Enter Industry" [ngClass]="{ 'is-invalid': clientForm.submitted && industry.errors }" maxlength="25" whiteSpaceValidator [disabled]="action == 'View'" [(ngModel)]="client.industry" />
      <div *ngIf="clientForm.submitted && industry.errors" class="invalid-feedback">
        <div *ngIf="industry.errors['required']"></div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group">
      <label>Job Title/Position </label> <label *ngIf="action != 'View'" class="danger">*</label>
      <input type="text" class="form-control" placeholder="Enter JobTitle or Position" #jobTitleOrPosition="ngModel" [ngClass]="{ 'is-invalid': clientForm.submitted && jobTitleOrPosition.errors }" maxlength="20" whiteSpaceValidator required name="jobTitleOrPosition" [disabled]="action == 'View'" [(ngModel)]="client.jobTitleOrPosition" />
      <div *ngIf="clientForm.submitted && jobTitleOrPosition.errors" class="invalid-feedback">
        <div *ngIf="jobTitleOrPosition.errors['required']"></div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group">
      <label>Website </label>
      <input type="text" class="form-control" placeholder="Enter Website" #website="ngModel" pattern="^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$" [ngClass]="{ 'is-invalid': clientForm.submitted && website.errors }" name="website" maxlength="35" whiteSpaceValidator [disabled]="action == 'View'" [(ngModel)]="client.website" />
      <div *ngIf="clientForm.submitted && website.errors" class="invalid-feedback">
        <div *ngIf="website.errors['required']"></div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-4">
    <div class="form-group">
      <label>E-mail id </label> <label *ngIf="action != 'View'" class="danger">*</label>
      <input type="text" class="form-control" placeholder="Enter Company EmailID" #companyEmailAddress="ngModel" [ngClass]="{ 'is-invalid': clientForm.submitted && companyEmailAddress.errors }" pattern="^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$" maxlength="35" whiteSpaceValidator email required name="companyEmailAddress" [disabled]="action == 'View'" [(ngModel)]="client.companyEmailAddress" />
      <div *ngIf="clientForm.submitted && companyEmailAddress.errors" class="invalid-feedback">
        <div *ngIf="companyEmailAddress.errors['required']"></div>
      </div>
    </div>
  </div>

  <div class="col-md-4">
    <div class="form-group">
      <label>Phone Number(Office) </label> <label *ngIf="action != 'View'" class="danger">*</label>
      <input type="text" class="form-control" #phoneNumberOffice="ngModel" placeholder="Enter Office PhoneNumber" [ngClass]="{ 'is-invalid': clientForm.submitted && phoneNumberOffice.errors }" required name="phoneNumberOffice" maxlength="10" minlength="10" whiteSpaceValidator numberValidator [disabled]="action == 'View'" [(ngModel)]="client.phoneNumberOffice" />
      <div *ngIf="clientForm.submitted && phoneNumberOffice.errors" class="invalid-feedback">
        <div *ngIf="phoneNumberOffice.errors['required']"></div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group">
      <label>Phone Number1 </label>
      <input type="text" class="form-control" name="phoneNumber1" placeholder="Enter PhoneNumber1(Optional)"
             #phoneNumber1="ngModel" [ngClass]="{ 'is-invalid': clientForm.submitted && phoneNumber1.errors }" minlength="10"
             maxlength="10" whiteSpaceValidator numberValidator [disabled]="action == 'View'" [(ngModel)]="client.phoneNumber1" />
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-4">
    <div class="form-group">
      <label>Phone Number2 </label>
      <input type="text" class="form-control" name="phoneNumber2" placeholder="Enter PhoneNumber2(Optional)" #phoneNumber2="ngModel"
             [ngClass]="{ 'is-invalid': clientForm.submitted && phoneNumber2.errors }" minlength="10" maxlength="10" whiteSpaceValidator numberValidator [disabled]="action == 'View'" [(ngModel)]="client.phoneNumber2" />
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group">
      <label>Country </label> <label *ngIf="action != 'View'" class="danger">*</label>
      <input type="text" class="form-control" required name="companyCountry" placeholder="Enter Country" pattern="^[a-zA-Z_ ]*$" #companyCountry="ngModel" [ngClass]="{ 'is-invalid': clientForm.submitted && companyCountry.errors }" maxlength="20" whiteSpaceValidator [disabled]="action == 'View'" [(ngModel)]="client.companyCountry" />
      <div *ngIf="clientForm.submitted && companyCountry.errors" class="invalid-feedback">
        <div *ngIf="companyCountry.errors['required']"></div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group">
      <label> City </label> <label *ngIf="action != 'View'" class="danger">*</label>
      <input type="text" class="form-control" placeholder="Enter City" #companyCity="ngModel" pattern="^[a-zA-Z_ ]*$" [ngClass]="{ 'is-invalid': clientForm.submitted && companyCity.errors }" required name="companyCity" maxlength="20" whiteSpaceValidator [disabled]="action == 'View'" [(ngModel)]="client.companyCity" />
      <div *ngIf="clientForm.submitted && companyCity.errors" class="invalid-feedback">
        <div *ngIf="companyCity.errors['required']"></div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-12">
    <div class="form-group">
      <label>Zip Code </label> <label *ngIf="action != 'View'" class="danger">*</label>
      <input type="text" class="form-control" required name="companyZipCode" placeholder="Enter Zipcode" #companyZipCode="ngModel" [ngClass]="{ 'is-invalid': clientForm.submitted && companyZipCode.errors }" minlength="6" maxlength="6" whiteSpaceValidator numberValidator [disabled]="action == 'View'" [(ngModel)]="client.companyZipCode" />
      <div *ngIf="clientForm.submitted && companyZipCode.errors" class="invalid-feedback">
        <div *ngIf="companyZipCode.errors['required']"></div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-12">
    <div class="form-group">
      <label>Company Address </label> <label *ngIf="action != 'View'" class="danger">*</label>
      <textarea class="form-control" id="basicTextarea" whiteSpaceValidator rows="3" placeholder="Enter Company Address" #companyAddress="ngModel" [ngClass]="{ 'is-invalid': clientForm.submitted && companyAddress.errors }" required name="companyAddress" [disabled]="action == 'View'" [(ngModel)]="client.companyAddress"></textarea>
      <div *ngIf="clientForm.submitted && companyAddress.errors" class="invalid-feedback">
        <div *ngIf="companyAddress.errors['required']"></div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-12">
    <div class="form-group">
      <label>Communication address </label> <label *ngIf="action != 'View'" class="danger">*</label>
      <textarea class="form-control" id="basicTextarea" rows="3" placeholder="Enter Communication Address" required #communicationAddress="ngModel" [ngClass]="{ 'is-invalid': clientForm.submitted && communicationAddress.errors }" whiteSpaceValidator name="communicationAddress" [disabled]="action == 'View'" [(ngModel)]="client.communicationAddress"></textarea>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-12">
    <div class="form-group">
      <label>Permanent address </label><label *ngIf="action != 'View'" class="danger">*</label>
      <ui-switch type="checkbox" class="switchery" name="samecommaddr" title="Same as Communication Address" [checked]="((action=='Edit'||action == 'View') && client.communicationAddress==client.permanentAddress)" (change)="updateAddrs($event)" switchColor="white" size="small" color="rgb(55, 188, 155)">
      </ui-switch>
      <textarea class="form-control" id="basicTextarea" rows="3" placeholder="Enter Permanent Address" required #permanentAddress="ngModel" [ngClass]="{ 'is-invalid': clientForm.submitted && permanentAddress.errors }" whiteSpaceValidator name="permanentAddress" [disabled]="action == 'View'" [(ngModel)]="client.permanentAddress"></textarea>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-12">
    <div class="form-group">
      <label>Please provide a brief description of the project or service your require assistance with:</label> <label *ngIf="action != 'View'" class="danger">*</label>
      <textarea class="form-control" id="basicTextarea" rows="3" maxlength="50" placeholder="Enter Assistance Required" #descriptionOfTheProjectOrServiceYouRequireAssistance="ngModel" [ngClass]="{ 'is-invalid': clientForm.submitted && descriptionOfTheProjectOrServiceYouRequireAssistance.errors }" whiteSpaceValidator required name="descriptionOfTheProjectOrServiceYouRequireAssistance" [disabled]="action == 'View'" [(ngModel)]="client.descriptionOfTheProjectOrServiceYouRequireAssistance"></textarea>
    </div>
  </div>
</div>
<div class="modal-header">
  <h4 class="modal-title" id="myModalLabel4">How did you hear about us?</h4>

</div>
<br />
<div class="row">
  <div class="col-md-12">
    <div class="form-group">

      <label>
        <input type="checkbox" name="onlineSearch" (change)="onlineSearch = $event.target.checked ? true: false" [(ngModel)]="client.onlineSearch">
        Online Search
      </label>
      <br />
      <label>
        <input type="checkbox" name="referralFromFriendOrFamilyMember" (change)="referralFromFriendOrFamilyMember = $event.target.checked ? true: false" [(ngModel)]="client.referralFromFriendOrFamilyMember">
        Referral from a friend/family member
      </label>
      <br />
      <label>
        <input type="checkbox" name="socialMedia" (change)="socialMedia = $event.target.checked ? true: false" [(ngModel)]="client.socialMedia">
        Social media
      </label>
      <br />
      <label>
        <input type="checkbox" (change)="advertisement = $event.target.checked ? true: false" name="advertisement" [(ngModel)]="client.advertisement">
        Advertisement(please specify source)
      </label>
      <br />
      <label>
        <input type="checkbox" (change)="other = $event.target.checked ? true: false" name="other" [(ngModel)]="client.other">
        Other(please specify)
      </label>

    </div>
  </div>
</div>
<div class="modal-header">
  <h4 class="modal-title" id="myModalLabel4">Perferred Method of communication</h4>

</div>
<br />
<div class="row">
  <div class="col-md-4">
    <div class="form-group">
      <label>Email</label> <label *ngIf="action != 'View'" class="danger">*</label>
      <input type="text" class="form-control" required name="email" placeholder="Enter EmailID" #email="ngModel" [ngClass]="{ 'is-invalid': clientForm.submitted && email.errors }" pattern="^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$" maxlength="35" whiteSpaceValidator email [disabled]="action == 'View'" [(ngModel)]="client.email" />
      <div *ngIf="clientForm.submitted && email.errors" class="invalid-feedback">
        <div *ngIf="email.errors['required']"></div>
      </div>
    </div>
  </div>


  <div class="col-md-4">
    <div class="form-group">
      <label>Phone</label> <label *ngIf="action != 'View'" class="danger">*</label>
      <input type="text" class="form-control" placeholder="Enter PhoneNumber" #phone="ngModel"
             [ngClass]="{ 'is-invalid': clientForm.submitted && phone.errors }" required name="phone"
             minlength="10" maxlength="10" whiteSpaceValidator numberValidator [disabled]="action == 'View'"
             [(ngModel)]="client.phone" />
      <div *ngIf="clientForm.submitted && phone.errors" class="invalid-feedback">
        <div *ngIf="phone.errors['required']"></div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group">
      <label>In-person meetings </label> <label *ngIf="action != 'View'" class="danger">*</label>
      <input type="text" class="form-control" required name="inPersonMeetings" placeholder="Enter InPersonMeetings" #inPersonMeetings="ngModel" [ngClass]="{ 'is-invalid': clientForm.submitted && inPersonMeetings.errors }" maxlength="20" whiteSpaceValidator [disabled]="action == 'View'" [(ngModel)]="client.inPersonMeetings" />
      <div *ngIf="clientForm.submitted && inPersonMeetings.errors" class="invalid-feedback">
        <div *ngIf="inPersonMeetings.errors['required']"></div>
      </div>
    </div>
  </div>
</div>
<div class="modal-header">
  <h4 class="modal-title" id="myModalLabel4">Additional Comments/Questions</h4>
</div>
<br />
<div class="row">
  <div class="col-md-12">
    <div class="form-group">
      <label>Thank You Choosing Our Service,We will review your information and get in touch with you shortly</label>
      <textarea class="form-control" id="basicTextarea" rows="3" maxlength="50" placeholder="Enter the review your Information" whiteSpaceValidator name="thankYouForChoosingOurServices" [(ngModel)]="client.thankYouForChoosingOurServices"></textarea>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-12">
    <div class="form-group">
      <label>Redeem Point Value</label>
      <input type="text" class="form-control" id="basicTextarea" maxlength="4" numberValidator whiteSpaceValidator placeholder="Enter RedeemPointValue" name="redeemPointValue" [(ngModel)]="client.redeemPointValue" />
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-4" *ngIf="ProductUID=='00000020-0000-0000-0000-000000000000'">
    <div class="form-group">
      <label>Membership Renewal Days Count</label>
      <input type="text" class="form-control" name="renewalDaysCount" placeholder="Enter RenewalDaysCount" numberValidatior maxlength="1" #renewalDaysCount="ngModel" [ngClass]="{ 'is-invalid': clientForm.submitted && renewalDaysCount.errors }" whiteSpaceValidator [disabled]="action == 'View'" [(ngModel)]="client.renewalDaysCount" />
    </div>
  </div>
  <div class="col-md-4" *ngIf="ProductUID!='00000020-0000-0000-0000-000000000000'">
    <div class="form-group">
      <br />
      <br />
      <label>Registration Date:{{currentDate | date:'dd-MM-yyyy'}}</label>
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group">
      <label>Joining Date</label> <label *ngIf="action != 'View'" class="danger">*</label>
      <div class="input-group">
        <input class="form-control" required [disabled]="action == 'View'" [min]="getToday()" placeholder="yyyy-mm-dd" name="joiningDate"
               [(ngModel)]="client.joiningDate" #joiningDate="ngModel" [ngClass]="{ 'is-invalid': clientForm.submitted && joiningDate.errors }" data-date-format="DD MMMM YYYY" type="date">
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group" novalidate >
      <label>Signature</label><label *ngIf="action != 'View'" class="danger">*</label>
      <div class="custom-file">-->
<!--(change)="onFileChange($event.target.files)"-->
<!--<input type="file" class="custom-file-input" id="importFile" accept="image/*" required (change)="onFileChangeSignature($event.target.files)">
        <label class="custom-file-label">{{signatureChoosefile}}</label>
      </div>
    </div>
  </div>

</div>
<div class="row">
  <div class="col-md-12">
    <div class="form-group">
      <label>-->
<!--(change)="informationProvidedTheBestOfMyKnowledge = $event.target.checked ? true: false"-->
<!--<input type="checkbox" name="informationProvidedTheBestOfMyKnowledge" [(ngModel)]="!client.informationProvidedTheBestOfMyKnowledge" (ngModelChange)="client.informationProvidedTheBestOfMyKnowledge=!$event">
            I hereby declare that the information provided above is true and accurate to the best of my knowledge.<label *ngIf="action != 'View'" class="danger">*</label>
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>
            <input type="checkbox" name="confidentialBusinessPurposes" [(ngModel)]="!client.confidentialBusinessPurposes" (ngModelChange)="client.confidentialBusinessPurposes=!$event">
            Please fill out this form to register as a client with our company.Your information will be kept confidential and used solely for business purposes.<label *ngIf="action != 'View'" class="danger">*</label>
          </label>
        </div>
      </div>
    </div>

  </div>
</div>
<div class="modal-footer">-->
<!--(click)="d('Close modal')"-->
<!--<button type="button" class="btn grey btn-outline-secondary"
        (click)="closePopup(clientForm,ClientChangesConfirmation)">
  Close
</button>-->
<!--(click)="SaveClient(clientForm)"-->
<!--<button type="submit" *ngIf="action != 'View'" class="btn grey btn-outline-secondary">Save</button>
        </div>
      </form>
    </div>
  </div>
</div>

<ng-template class="modal text-left ChangesConfirmation" #ClientChangesConfirmation let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="mymodallabel4">confirmation</h4>
    <button type="button" class="close" aria-label="close" (click)="d('cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Are you sure that you want to leave the current page? The changes that you made won't be saved.</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn grey btn-outline-secondary"
            (click)="ViewPopup(ClientContent,action,client)">
      no
    </button>
    <button type="button" class="btn btn-outline-primary" (click)="d('cross click')">yes</button>
  </div>
</ng-template>-->
<!--<div class="auth-shell">-->
<!-- ── LEFT: branding panel ─────────────────────────────────── -->
<!--<aside class="auth-brand">
  <div class="auth-brand-logo">
    <img src="assets/custom/images/abg/kg logo.jpeg" alt="KG Technologys" />
    <span>KG Technologys</span>
  </div>
  <h1 class="auth-brand-headline">Tell us about your organization.</h1>
  <p class="auth-brand-sub">
    Your company profile powers billing, documents, branding and tenant isolation across every module.
  </p>
  <ul class="auth-brand-features">
    <li><i class="la la-building"></i> One secure profile per organization</li>
    <li><i class="la la-shield"></i> Tenant-isolated by design</li>
    <li><i class="la la-file-text"></i> GST, PAN &amp; statutory documents</li>
    <li><i class="la la-cloud-upload"></i> Secure document uploads</li>
  </ul>
  <div class="auth-brand-footer">&copy; KG Technologys. All rights reserved.</div>
</aside>-->
<!-- ── RIGHT: form ──────────────────────────────────────────── -->
<!--<main class="auth-main">
  <div class="auth-card cd-card">

    <div class="auth-mobile-logo">
      <img src="assets/custom/images/abg/kg logo.jpeg" alt="KG Technologys" />
    </div>-->
<!-- Auto-generated identifiers -->
<!--<div class="cd-ids">
  <div class="cd-id">
    <span class="cd-id-label">Registration No.</span>
    <span class="cd-id-value">{{ registrationNumber || '—' }}</span>
  </div>
  <div class="cd-id">
    <span class="cd-id-label">Tenant ID</span>
    <span class="cd-id-value cd-id-guid" title="{{ tenantId }}">{{ tenantId }}</span>
  </div>
</div>-->
<!-- Stepper -->
<!--<div class="cd-steps">
  <div class="cd-step" [ngClass]="{ active: step === 1, done: step > 1 }" (click)="goTo(1)">
    <span class="cd-step-dot"><i class="la" [ngClass]="step > 1 ? 'la-check' : 'la-building'"></i></span>
    <span class="cd-step-label">Company</span>
  </div>
  <div class="cd-step-line" [ngClass]="{ done: step > 1 }"></div>
  <div class="cd-step" [ngClass]="{ active: step === 2, done: step > 2 }" (click)="goTo(2)">
    <span class="cd-step-dot"><i class="la" [ngClass]="step > 2 ? 'la-check' : 'la-user'"></i></span>
    <span class="cd-step-label">Contact</span>
  </div>
  <div class="cd-step-line" [ngClass]="{ done: step > 2 }"></div>
  <div class="cd-step" [ngClass]="{ active: step === 3, done: step > 3 }" (click)="goTo(3)">
    <span class="cd-step-dot"><i class="la" [ngClass]="step > 3 ? 'la-check' : 'la-cube'"></i></span>
    <span class="cd-step-label">Plan</span>
  </div>
  <div class="cd-step-line" [ngClass]="{ done: step > 3 }"></div>
  <div class="cd-step" [ngClass]="{ active: step === 4 }" (click)="goTo(4)">
    <span class="cd-step-dot"><i class="la la-cloud-upload"></i></span>
    <span class="cd-step-label">Documents</span>
  </div>
</div>-->
<!-- Banners -->
<!--<div class="auth-banner auth-banner--error" *ngIf="errorMessage">
  <i class="la la-exclamation-circle"></i> <span>{{ errorMessage }}</span>
</div>
<div class="auth-banner auth-banner--success" *ngIf="successMessage">
  <i class="la la-check-circle"></i> <span>{{ successMessage }}</span>
</div>

<form [formGroup]="form" novalidate (ngSubmit)="submit()">-->
<!-- ═══════════ STEP 1 — COMPANY INFORMATION ═══════════ -->
<!--<section *ngIf="step === 1">
  <h2 class="auth-title">Company information</h2>
  <p class="auth-sub">Legal and contact details of your organization.</p>

  <div class="cd-grid">
    <div class="auth-field">
      <label class="auth-label">Company Name <span class="cd-req">*</span></label>
      <input type="text" class="auth-input" formControlName="companyName" placeholder="Company / Brand name"
             [ngClass]="{ 'is-invalid': f.companyName.touched && f.companyName.errors }" />
      <div class="auth-error" *ngIf="f.companyName.touched && f.companyName.errors?.required">Company name is required</div>
    </div>

    <div class="auth-field">
      <label class="auth-label">Company Legal Name</label>
      <input type="text" class="auth-input" formControlName="companyLegalName" placeholder="Registered legal name" />
    </div>

    <div class="auth-field">
      <label class="auth-label">Company Type</label>
      <select class="auth-input" formControlName="companyType">
        <option value="">Select type</option>
        <option *ngFor="let t of companyTypes" [value]="t">{{ t }}</option>
      </select>
    </div>

    <div class="auth-field">
      <label class="auth-label">Industry</label>
      <input type="text" class="auth-input" formControlName="industry" placeholder="e.g. Retail, Logistics" />
    </div>

    <div class="auth-field">
      <label class="auth-label">Company Registration Number</label>
      <input type="text" class="auth-input" formControlName="companyRegistrationNumber" placeholder="ROC / incorporation no." />
    </div>

    <div class="auth-field">
      <label class="auth-label">CIN Number</label>
      <input type="text" class="auth-input" formControlName="cinNumber" placeholder="21-char CIN" maxlength="21" />
    </div>

    <div class="auth-field">
      <label class="auth-label">GST Number</label>
      <input type="text" class="auth-input" formControlName="gstNumber" placeholder="15-char GSTIN" maxlength="15"
             style="text-transform:uppercase"
             [ngClass]="{ 'is-invalid': f.gstNumber.touched && f.gstNumber.errors }" />
      <div class="auth-error" *ngIf="f.gstNumber.touched && f.gstNumber.errors?.pattern">Enter a valid 15-character GSTIN</div>
    </div>

    <div class="auth-field">
      <label class="auth-label">PAN Number</label>
      <input type="text" class="auth-input" formControlName="panNumber" placeholder="AAAAA9999A" maxlength="10"
             style="text-transform:uppercase"
             [ngClass]="{ 'is-invalid': f.panNumber.touched && f.panNumber.errors }" />
      <div class="auth-error" *ngIf="f.panNumber.touched && f.panNumber.errors?.pattern">Enter a valid PAN (AAAAA9999A)</div>
    </div>

    <div class="auth-field">
      <label class="auth-label">MSME / UDYAM Number</label>
      <input type="text" class="auth-input" formControlName="msmeUdyamNumber" placeholder="UDYAM-XX-00-0000000" />
    </div>

    <div class="auth-field">
      <label class="auth-label">IEC Number <span class="cd-opt">(optional)</span></label>
      <input type="text" class="auth-input" formControlName="iecNumber" placeholder="Import-Export Code" />
    </div>

    <div class="auth-field">
      <label class="auth-label">Company Email <span class="cd-req">*</span></label>
      <input type="email" class="auth-input" formControlName="companyEmail" placeholder="info@company.com"
             [ngClass]="{ 'is-invalid': f.companyEmail.touched && f.companyEmail.errors }" />
      <div class="auth-error" *ngIf="f.companyEmail.touched && f.companyEmail.errors?.required">Email is required</div>
      <div class="auth-error" *ngIf="f.companyEmail.touched && f.companyEmail.errors?.email">Enter a valid email</div>
    </div>

    <div class="auth-field">
      <label class="auth-label">Company Website</label>
      <input type="text" class="auth-input" formControlName="companyWebsite" placeholder="https://" />
    </div>

    <div class="auth-field">
      <label class="auth-label">Company Phone <span class="cd-req">*</span></label>
      <input type="text" class="auth-input" formControlName="companyPhone" placeholder="Primary phone" maxlength="10"
             [ngClass]="{ 'is-invalid': f.companyPhone.touched && f.companyPhone.errors }" />

    </div>

    <div class="auth-field">
      <label class="auth-label">Alternate Phone</label>
      <input type="text" class="auth-input" formControlName="alternatePhone" placeholder="Alternate phone"
             [ngClass]="{ 'is-invalid': f.alternatePhone.touched && f.alternatePhone.errors }" />
      <div class="auth-error" *ngIf="f.alternatePhone.touched && f.alternatePhone.errors">Enter a valid phone number</div>
    </div>

    <div class="auth-field cd-col-2">
      <label class="auth-label">Company Address</label>
      <input type="text" class="auth-input" formControlName="companyAddress" placeholder="Street, area, landmark" />
    </div>

    <div class="auth-field">
      <label class="auth-label">City <span class="cd-req">*</span></label>
      <input type="text" class="auth-input" formControlName="city" placeholder="City" />
    </div>

    <div class="auth-field">
      <label class="auth-label">State< <span class="cd-req">*</span></label>
      <input type="text" class="auth-input" formControlName="state" placeholder="State" />
    </div>

    <div class="auth-field">
      <label class="auth-label">Country <span class="cd-req">*</span></label>
      <input type="text" class="auth-input" formControlName="country" placeholder="Country" />
    </div>

    <div class="auth-field">
      <label class="auth-label">PIN Code <span class="cd-req">*</span></label>
      <input type="text" class="auth-input" formControlName="pinCode" placeholder="6-digit PIN" maxlength="6"
             [ngClass]="{ 'is-invalid': f.pinCode.touched && f.pinCode.errors }" />
      <div class="auth-error" *ngIf="f.pinCode.touched && f.pinCode.errors?.pattern">Enter a valid 6-digit PIN</div>
    </div>
  </div>
</section>-->
<!-- ═══════════ STEP 2 — CONTACT PERSON ═══════════ -->
<!--<section *ngIf="step === 2">
  <h2 class="auth-title">Contact person</h2>
  <p class="auth-sub">The primary point of contact for this organization.</p>

  <div class="cd-grid">
    <div class="auth-field">
      <label class="auth-label">Full Name <span class="cd-req">*</span></label>
      <input type="text" class="auth-input" formControlName="contactFullName" placeholder="Contact full name"
             [ngClass]="{ 'is-invalid': f.contactFullName.touched && f.contactFullName.errors }" />
      <div class="auth-error" *ngIf="f.contactFullName.touched && f.contactFullName.errors?.required">Full name is required</div>
    </div>

    <div class="auth-field">
      <label class="auth-label">Designation</label>
      <input type="text" class="auth-input" formControlName="contactDesignation" placeholder="e.g. Director, Manager" />
    </div>

    <div class="auth-field">
      <label class="auth-label">Mobile Number <span class="cd-req">*</span></label>
      <input type="text" class="auth-input" formControlName="contactMobile" placeholder="10-digit mobile" maxlength="10"
             [ngClass]="{ 'is-invalid': f.contactMobile.touched && f.contactMobile.errors }" />
      <div class="auth-error" *ngIf="f.contactMobile.touched && f.contactMobile.errors">Enter a valid 10-digit mobile</div>
    </div>

    <div class="auth-field">
      <label class="auth-label">Email</label>
      <input type="email" class="auth-input" formControlName="contactEmail" placeholder="contact@company.com"
             [ngClass]="{ 'is-invalid': f.contactEmail.touched && f.contactEmail.errors }" />
      <div class="auth-error" *ngIf="f.contactEmail.touched && f.contactEmail.errors?.email">Enter a valid email</div>
    </div>

    <div class="auth-field">
      <label class="auth-label">Alternate Contact</label>
      <input type="text" class="auth-input" formControlName="alternateContact" placeholder="Alternate 10-digit number" maxlength="10"
             [ngClass]="{ 'is-invalid': f.alternateContact.touched && f.alternateContact.errors }" />
      <div class="auth-error" *ngIf="f.alternateContact.touched && f.alternateContact.errors">Enter a valid 10-digit number</div>
    </div>
  </div>
</section>-->
<!-- ═══════════ STEP 3 — SUBSCRIPTION ═══════════ -->
<!--<section *ngIf="step === 3">
  <h2 class="auth-title">Subscription</h2>
  <p class="auth-sub">Choose your product and plan.</p>

  <div class="cd-grid">
    <div class="auth-field cd-col-2">
      <label class="auth-label">Product <span class="cd-req">*</span></label>
      <select class="auth-input" formControlName="productUId"
              [ngClass]="{ 'is-invalid': f.productUId.touched && f.productUId.errors }">
        <option value="">Select product</option>
        <option *ngFor="let p of products" [value]="p.productUId">{{ p.productName }}</option>
      </select>
      <div class="auth-error" *ngIf="f.productUId.touched && f.productUId.errors?.required">Please select a product</div>
    </div>

    <div class="auth-field">
      <label class="auth-label">License Type</label>
      <select class="auth-input" formControlName="licenseType">
        <option *ngFor="let l of licenseTypes" [value]="l">{{ l }}</option>
      </select>
    </div>

    <div class="auth-field">
      <label class="auth-label">Subscription Plan</label>
      <select class="auth-input" formControlName="subscriptionPlan">
        <option *ngFor="let s of subscriptionPlans" [value]="s">{{ s }}</option>
      </select>
    </div>

    <div class="auth-field">
      <label class="auth-label">Registration Date <span class="cd-req">*</span></label>
      <input type="date" class="auth-input" formControlName="registrationDate"
             [ngClass]="{ 'is-invalid': f.registrationDate.touched && f.registrationDate.errors }" />
    </div>

    <div class="auth-field">
      <label class="auth-label">Renewal Date</label>
      <input type="date" class="auth-input" formControlName="renewalDate" />
    </div>

    <div class="auth-field">
      <label class="auth-label">Status</label>
      <select class="auth-input" formControlName="status">
        <option value="Active">Active</option>
        <option value="Trial">Trial</option>
        <option value="Pending">Pending</option>
        <option value="Suspended">Suspended</option>
        <option value="Inactive">Inactive</option>
      </select>
    </div>
  </div>
</section>-->
<!-- ═══════════ STEP 4 — DOCUMENTS ═══════════ -->
<!--<section *ngIf="step === 4">
  <h2 class="auth-title">Documents</h2>
  <p class="auth-sub">PDF, JPG or PNG. Max 5 MB each. Logo accepts images only.</p>

  <div class="cd-uploads">
    <div class="cd-upload" *ngFor="let d of docs" [ngClass]="{ 'has-file': d.file, 'has-error': d.error }">
      <div class="cd-upload-head">
        <i class="la" [ngClass]="d.file ? 'la-check-circle' : 'la-cloud-upload'"></i>
        <span class="cd-upload-label">{{ d.label }}</span>
      </div>
      <label class="cd-upload-btn">
        <span>{{ d.fileName }}</span>
        <input type="file"
               [accept]="d.imageOnly ? 'image/*' : '.pdf,image/*'"
               (change)="onFileSelected($event, d)" hidden />
      </label>
      <div class="auth-error" *ngIf="d.error">{{ d.error }}</div>
    </div>
  </div>

  <div class="cd-review">
    <div class="cd-review-row"><span>Company</span><strong>{{ f.companyName.value || '—' }}</strong></div>
    <div class="cd-review-row"><span>Registration No.</span><strong>{{ registrationNumber || '—' }}</strong></div>
    <div class="cd-review-row"><span>Contact</span><strong>{{ f.contactFullName.value || '—' }} · {{ f.contactMobile.value || '—' }}</strong></div>
    <div class="cd-review-row"><span>Plan</span><strong>{{ f.licenseType.value }} · {{ f.subscriptionPlan.value }}</strong></div>
  </div>
</section>-->
<!-- ═══════════ NAVIGATION ═══════════ -->
<!--<div class="cd-actions">
          <button type="button" class="auth-btn cd-btn-ghost" *ngIf="step > 1" (click)="prev()">
            <i class="la la-arrow-left"></i> <span>Back</span>
          </button>
          <button type="button" class="auth-btn cd-btn-ghost" *ngIf="step === 1" (click)="changeDetails()">
            <i class="la la-arrow-left"></i> <span>Account</span>
          </button>

          <button type="button" class="auth-btn auth-btn-primary" *ngIf="step < totalSteps" (click)="next()">
            <span>Continue</span> <i class="la la-arrow-right"></i>
          </button>

          <button type="submit" class="auth-btn auth-btn-primary" *ngIf="step === totalSteps" [disabled]="loading">
            <i class="fa fa-refresh fa-spin" *ngIf="loading"></i>
            <span>{{ loading ? 'Saving...' : 'Save & Continue' }}</span>
          </button>
        </div>
      </form>
    </div>
  </main>
</div>-->



<div class="ci-wrap">
  <div class="ci-card">
    <h1 class="ci-title">Tell us about your organization</h1>
    <p class="ci-sub">One more step before you get to your dashboard.</p>

    <div *ngIf="errorMessage" class="ci-alert ci-alert--error" role="alert">{{ errorMessage }}</div>
    <div *ngIf="successMessage" class="ci-alert ci-alert--ok" role="status">{{ successMessage }}</div>

    <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
      <div class="ci-field">
        <label for="ci-companyName">Company name *</label>
        <input id="ci-companyName" type="text" formControlName="companyName" class="ci-input"
               [class.ci-input--invalid]="submitted && f.companyName.errors" />
        <div class="ci-error" *ngIf="submitted && f.companyName.errors">Company name is required.</div>
      </div>

      <div class="ci-row">
        <div class="ci-field">
          <label for="ci-companyType">Company type</label>
          <select id="ci-companyType" formControlName="companyType" class="ci-input">
            <option value="">Select...</option>
            <option *ngFor="let t of companyTypes" [value]="t">{{ t }}</option>
          </select>
        </div>
        <div class="ci-field">
          <label for="ci-industry">Industry</label>
          <select id="ci-industry" formControlName="industry" class="ci-input">
            <option value="">Select...</option>
            <option *ngFor="let i of industries" [value]="i">{{ i }}</option>
          </select>
        </div>
      </div>

      <div class="ci-row">
        <div class="ci-field">
          <label for="ci-companyEmail">Company email *</label>
          <input id="ci-companyEmail" type="email" formControlName="companyEmail" class="ci-input"
                 [class.ci-input--invalid]="submitted && f.companyEmail.errors" />
          <div class="ci-error" *ngIf="submitted && f.companyEmail.errors">A valid company email is required.</div>
        </div>
        <div class="ci-field">
          <label for="ci-companyPhone">Company phone *</label>
          <input id="ci-companyPhone" type="text" formControlName="companyPhone" class="ci-input"
                 [class.ci-input--invalid]="submitted && f.companyPhone.errors" />
          <div class="ci-error" *ngIf="submitted && f.companyPhone.errors">A valid phone number is required.</div>
        </div>
      </div>

      <div class="ci-field">
        <label for="ci-companyAddress">Address</label>
        <input id="ci-companyAddress" type="text" formControlName="companyAddress" class="ci-input" />
      </div>

      <div class="ci-row ci-row--3">
        <div class="ci-field">
          <label for="ci-city">City</label>
          <input id="ci-city" type="text" formControlName="city" class="ci-input" />
        </div>
        <div class="ci-field">
          <label for="ci-state">State</label>
          <input id="ci-state" type="text" formControlName="state" class="ci-input" />
        </div>
        <div class="ci-field">
          <label for="ci-pinCode">PIN code</label>
          <input id="ci-pinCode" type="text" formControlName="pinCode" class="ci-input"
                 [class.ci-input--invalid]="submitted && f.pinCode.errors" />
          <div class="ci-error" *ngIf="submitted && f.pinCode.errors">Enter a valid PIN code.</div>
        </div>
      </div>

      <div class="ci-field">
        <label for="ci-contactFullName">Primary contact name *</label>
        <input id="ci-contactFullName" type="text" formControlName="contactFullName" class="ci-input"
               [class.ci-input--invalid]="submitted && f.contactFullName.errors" />
        <div class="ci-error" *ngIf="submitted && f.contactFullName.errors">Contact name is required.</div>
      </div>

      <button type="submit" class="ci-btn ci-btn--primary" [disabled]="loading">
        {{ loading ? 'Saving…' : 'Continue' }}
      </button>
    </form>
  </div>
</div>


